import { render, staticRenderFns } from "./CancerCoachingStart.vue?vue&type=template&id=36883582"
import script from "./CancerCoachingStart.vue?vue&type=script&lang=js"
export * from "./CancerCoachingStart.vue?vue&type=script&lang=js"
import style0 from "./CancerCoachingStart.vue?vue&type=style&index=0&id=36883582&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports